<tr class="blank-row two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3"></td>
  <td class="blank-space col-fifth-level"></td>
  @for (header of budgetFormValue$$().modelHeaders; track header; let last = $last) {
    @if (header.type === BmPeriodEnum.QUARTER) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed || collapsedYears().get(header.yearNumber)">
      </td>
    }
    @if (header.type === BmPeriodEnum.YEAR && !last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed || collapsedYears().get(header.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td></td>
  <td class="blank-space right-sticky right-[11rem]"></td>
  <td class="right-sticky right-[5.5rem]"></td>
  <td class="right-sticky right-0"></td>
</tr>
<tr class="total two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3">Total expenses</td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.totalExpenses.values; track data) {
    <td
      [attr.data-qa]="'bm-total-expenses-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
      [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
      [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)"
      class="bold600">
      {{ data.itemValue | switcherDashBraces : 1 : 0 }}
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="blank-space right-sticky right-[11rem]"></td>
  <td [attr.data-qa]="'bm-total-expenses-row'"
      class="right-sticky right-[5.5rem] bold600">{{ budgetFormValue$$().modelData.totalExpenses.totalRow | switcherDashBraces : 1 : 0 }}
  </td>
  <td [attr.data-qa]="'bm-total-expenses-row-pcnt'"
      class="right-sticky right-0 bold600">{{ budgetFormValue$$().modelData.totalExpenses.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%' }}
  </td>
</tr>
<tr class="total two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3">Total expenses, %</td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.totalExpenses.pcnt; track data) {
    <td
      [attr.data-qa]="'bm-total-expenses-pcnt-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
      [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
      [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)"
      class="bold600">
      {{ data.itemValue | switcherDashBraces : 1 : 1 : false :  '' : '%' }}
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="blank-space right-sticky right-[11rem]"></td>
  <td data-qa="bm-total-expenses-row" class="right-sticky right-[5.5rem] bold600"></td>
  <td class="right-sticky right-0"></td>
</tr>
<tr class="blank-row two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3"></td>
  <td class="blank-space col-fifth-level"></td>
  @for (p of budgetFormValue$$().modelHeaders; track $index; let last = $last) {
    @if (p.type === BmPeriodEnum.QUARTER) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed || collapsedYears().get(p.yearNumber)">
      </td>
    }
    @if (p.type === BmPeriodEnum.YEAR && !last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed || collapsedYears().get(p.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td></td>
  <td class="blank-space right-sticky right-[11rem]"></td>
  <td class="right-sticky right-[5.5rem]"></td>
  <td class="right-sticky right-0"></td>
</tr>

<!-- Investment  -->
<tr class="bg-black-1 two-columns-group-sticky" appOnHover #investment_tr="onHover">
  <td class="col-first-level">
    <app-table-group-icon data-qa="bm-hide-inv-section"
                          [formControl]="budgetForm().controls.modelData.controls.investment.controls.showSection"/>
  </td>
  <td class="col-second-level" colspan="3">
    <div class="flex justify-between items-center">
      <div class="bold600">Investment</div>
      @if (isEditState()) {
        <app-input
          data-qa="bm-inv-value"
          class="w-[8.7rem]"
          [formControl]="budgetForm().controls.modelData.controls.investment.controls.investmentValue"
          [isShrinked]="true"
          [thousandSeparator]="','"
          [separator]="'separator.0'">
        </app-input>
      }
    </div>
  </td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.investment.itemsValue; track data; let last = $last) {
    @let dataControl = budgetForm().controls.modelData.controls.investment.controls.itemsValue.controls[$index];
    <td class="bold600"
        [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
        [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
      @if (data.period.type === BmPeriodEnum.YEAR) {
        @if (isEditState()) {
          <app-input
            [attr.data-qa]="'bm-inv-val-item-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
            [formControl]="dataControl.controls.itemValue"
            [isShrinked]="true"
            [thousandSeparator]="','"
            [separator]="'separator.0'"
            [suffixFirstIcon]="data.period.type === BmPeriodEnum.YEAR ? (dataControl.controls.itemValue.disabled ? (investment_tr.hovered() ? 'edit.svg' : ''): 'close.svg'): ''"
            (suffixFirstIconEmitter)="editItemValue(dataControl, BmGroupType.INVESTMENT_VALUE)">
          </app-input>
        } @else {
          <span
            [attr.data-qa]="'bm-inv-val-item-val'+ data.period.quarterNumber + '-' + data.period.yearNumber">
              {{ data.itemValue | switcherDashBraces : 1 : 0 }}
            </span>
        }
      } @else {
        <span
          [attr.data-qa]="'bm-inv-val-item-val'+ data.period.quarterNumber + '-' + data.period.yearNumber">
            {{ data.itemValue | switcherDashBraces : 1 : 0 }}
          </span>
      }
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="blank-space right-sticky right-[11rem]"></td>
  <td data-qa="bm-inv-row"
      class="right-sticky right-[5.5rem] bold600">{{ budgetFormValue$$().modelData.investment.totalRow | switcherDashBraces : 1 : 0 }}
  </td>
  <td data-qa="bm-inv-row-pcnt"
      class="right-sticky right-0 bold600">{{ budgetFormValue$$().modelData.investment.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%' }}
  </td>
</tr>
@if (budgetForm().value.modelData.investment.showSection) {
  <tr appOnHover #investment_pcnt_tr="onHover" class="two-columns-group-sticky">
    <td class="col-first-level"></td>
    <td
      data-qa="bm-inv-rest-pcnt"
      class="col-second-level"
      colspan="3">Investment, % (
      {{ budgetFormValue$$().modelData.investment.itemsPcntSum ? budgetFormValue$$().modelData.investment.itemsPcntSum.toFixed(0) + '%' : 'out' }}
      of 100%)
    </td>
    <td class="blank-space col-fifth-level"></td>
    <ng-container>
      @if (isEditState()) {
        @for (data of budgetFormValue$$().modelData.investment.itemsPcnt; track data; let last = $last) {
          @let dataControl = budgetForm().controls.modelData.controls.investment.controls.itemsPcnt.controls[$index];
          <td
            [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
            [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
            <app-input
              [attr.data-qa]="'bm-inv-pcnt-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
              [formControl]="dataControl.controls.itemValue"
              [isShrinked]="true"
              [thousandSeparator]="','"
              [separator]="'separator.2'"
              [suffix]="'%'"
              [suffixFirstIcon]="data.period.type === BmPeriodEnum.YEAR ? (dataControl.controls.itemValue.disabled ? (investment_pcnt_tr.hovered() ? 'edit.svg' : ''): 'close.svg'): ''"
              (suffixFirstIconEmitter)="editItemValue(dataControl, BmGroupType.INVESTMENT_PCNT)">
            </app-input>
          </td>
          @if (data.period.type === BmPeriodEnum.YEAR && !last) {
            <td
              [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
              class="blank-space">
            </td>
          }
        }
      } @else {
        @for (data of budgetFormValue$$().modelData.investment.itemsPcnt; track data; let last = $last) {
          <td
            [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)"
            [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
            [attr.data-qa]="'bm-inv-pcnt-val-'+ data.period.quarterNumber + '-' + data.period.yearNumber">
            {{ data.itemValue | switcherDashBraces : 1 : 2: false : '' : '%' }}
          </td>
          @if (data.period.type === BmPeriodEnum.YEAR && !last) {
            <td
              [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
              class="blank-space">
            </td>
          }
        }
      }
      <td [class.bg-black-2]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
      <td class="blank-space right-sticky right-[11rem]"></td>
      <td class="right-sticky right-[5.5rem]"></td>
      <td class="right-sticky right-0"></td>
    </ng-container>
  </tr>
}
